import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  heading: {
    marginTop: theme.spacing(4),
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.light,
    backgroundColor: theme.palette.primary.selected,
    borderRadius: 40,
    minWidth: 40,
    minHeight: 40,
  },
  iconDisabled: {
    color: 'rgba(0, 0, 0, 0.54)',
    backgroundColor: 'rgba(0, 0, 0, 0.26)',
    '& path': {
      fill: 'rgba(0, 0, 0, 0.54) !important',
    },
  },
  mainWrapper: {
    textDecoration: 'none',
    display: 'grid',
    height: '100%',
  },
  action: {
    marginLeft: 'auto',
    paddingRight: theme.spacing(2),
    [theme.breakpoints.only('xs')]: {
      paddingRight: 0,
    },
    color: 'rgba(0, 0, 0, 0.54)',
  },
  adornedEnd: {
    paddingRight: '8px',
    '& button': {
      padding: 0,
    },
  },
  disabled: {
    cursor: 'default',
    pointerEvents: 'none',
  },
  ctaButton: {
    pointerEvents: 'all',
    marginTop: theme.spacing(1),
    marginLeft: -theme.spacing(1),
  },
}))

export default useStyles
